import { render, staticRenderFns } from "./ShopCategories.vue?vue&type=template&id=00a563c6"
import script from "./ShopCategories.vue?vue&type=script&lang=js"
export * from "./ShopCategories.vue?vue&type=script&lang=js"
import style0 from "./ShopCategories.vue?vue&type=style&index=0&id=00a563c6&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a563c6')) {
      api.createRecord('00a563c6', component.options)
    } else {
      api.reload('00a563c6', component.options)
    }
    module.hot.accept("./ShopCategories.vue?vue&type=template&id=00a563c6", function () {
      api.rerender('00a563c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ShopCategories.vue"
export default component.exports